module.exports = __webpack_public_path__ + "static/BrandyBottle1-8fb2bffa19ec4d443f6a950fed1573a8.jpg";